var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group col-md-12 mb-4"},[_c('div',{staticClass:"form-group mb-2 mb-md-0"},[_c('div',{staticClass:"info-box"},[_vm._v(" "+_vm._s(_vm.selected))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }